import axios from "axios";

import { store } from "redux/store";

import {
  IChoiceMerchantRequest,
  IChoiceMerchant,
} from "models/Login/choiceMerchant.model";

export const Merchant = async (): Promise<IChoiceMerchant> => {
  const reduxStore = store.getState();
  let merchantParams: IChoiceMerchantRequest = {};
  merchantParams.TokenSessionId =
    reduxStore.login.user?.tokenSessionID ||
    reduxStore.login.user?.TokenSessionId;

  const reqData = serviceMerchantModelCreator(merchantParams);

  try {
    const { data } = await axios.post<IChoiceMerchant>("/Token", reqData);

    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    return data;
  } catch (error) {
    console.log(`MERCHANT_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceMerchantModelCreator = (
  merchantParams: IChoiceMerchantRequest
) => {
  let req = {
    PageNo: "1",
    SearchText: "",
    CallbackFunctionId: null,
    isBusy: false,
    isNativeFlag: "true",
    Language: "tr-TR",
    TokenSessionId: merchantParams.TokenSessionId,
    igsEnc: null,
    NextTransactionUrl: "ModAuthSwitchMccGet",
  };

  return req;
};
